import { getKey, callOpenAICompat } from './shared';
import { t } from '../modules/i18n';

export async function callGroq(model, prompt, signal, opts) {
  const key = getKey("groq");
  if (!key) throw new Error(t("err.nokey", { provider: "Groq" }));
  return callOpenAICompat("Groq", "https://api.groq.com/openai/v1/chat/completions", key, model, prompt, signal, opts);
}
